import BasicLayout from '@/layouts/basic-layout'

const prefix = 'fin-actual-receivable-'
export default {
  path: '/financial-manage/fin-actual-receivable',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '实收管理-承'},
      component: () => import('@/pages/financial-manage/fin-actual-receivable/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '实收申请新增-承'},
      component: () => import('@/pages/financial-manage/fin-actual-receivable/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '实收申请编辑-承'},
      component: () => import('@/pages/financial-manage/fin-actual-receivable/detail-edit')
    },

    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '业主合同收付款情况详情-承'},
      component: () => import('@/pages/financial-manage/fin-actual-receivable/detail-view')
    }
  ]
}
